export enum BUPFieldsEnum {
  ULD_TYPE = "uldType",
  QUANTITY = "quantity",
  WEIGHT = "weight",
}
